import { useBoolean, useRequest } from 'ahooks'

import useSignal from '$actions/useSignal'

import { asyncSuccessResolver } from '$app/utilities'
import { successResolver } from '$services/api/common'

import session from '$store/session'
import { api } from '$model/api'

export const useMFAInfo = () => {
  const { current: sessionID } = useSignal(session)

  const {
    mfaAuth: { mfaInfoRequest }
  } = useSignal(api)

  // Track initial loading
  const [isDirty, { setTrue }] = useBoolean()

  const {
    data,
    loading,
    error,
    refreshAsync: refresh
  } = useRequest(asyncSuccessResolver(mfaInfoRequest, successResolver), {
    // https://github.com/alibaba/hooks/issues/2356#issue-1977838612
    cacheKey: `mfa-info:${sessionID}`,

    refreshDeps: [sessionID],
    refreshOnWindowFocus: true,
    onFinally: setTrue
  })
  const {
    registered_factors = [],
    preferred_factor,
    is_passkey_enabled,
    is_2fa_enforced,
    is_2fa_enabled
  } = { ...data?.data }

  const preferable_factors = registered_factors.filter(
    ({ type }) => type !== 'recovery_code'
  )

  const isLoading = !isDirty && loading
  const hasError = !!error === true
  const isEmpty = registered_factors.length === 0 || hasError

  return {
    isLoading,
    isEmpty,
    registered_factors,
    preferable_factors,
    preferred_factor,
    is_passkey_enabled,
    is_2fa_enforced,
    is_2fa_enabled,
    refresh
  }
}

export default useMFAInfo
